import { render, staticRenderFns } from "./Topup.vue?vue&type=template&id=f37c913a&scoped=true&"
import script from "./Topup.vue?vue&type=script&lang=js&"
export * from "./Topup.vue?vue&type=script&lang=js&"
import style0 from "./Topup.vue?vue&type=style&index=0&id=f37c913a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37c913a",
  null
  
)

export default component.exports